import React from 'react';
import { format } from 'date-fns-tz';
import utils from '../../utils';
import IconButton from '../../components/iconButton';

const mapStatusToClass = status => {
  switch (status) {
    case 'POINT_OF_SALE_REPORT_STATUS_UNSPECIFIED':
      return { statusClass: 'secondary', label: 'Undefined' };
    case 'POINT_OF_SALE_REPORT_PENDING_UPLOAD':
      return { statusClass: 'warning', label: 'Pending' };
    case 'POINT_OF_SALE_REPORT_UPLOADED':
      return { statusClass: 'success', label: 'Completed' };
    case 'POINT_OF_SALE_REPORT_ERROR':
      return { statusClass: 'danger', label: 'Error' };
    case 'POINT_OF_SALE_REPORT_COMPLETE':
      return { statusClass: 'success', label: 'Completed' };
    case 'POINT_OF_SALE_REPORT_DELETED':
      return { statusClass: 'danger', label: 'Deleted' };
    default:
      return { statusClass: 'secondary', label: 'Undefined' };
  }
};

const createColumns = callbackFunction => [
  {
    Header: 'File ID',
    id: 'fileId',
    type: 'string',
    disableSortBy: true,
    accessor: file => file.id || '--'
  },
  {
    Header: 'Upload Date',
    id: 'uploadDate',
    type: 'string',
    disableSortBy: true,
    accessor: file => (file.updateTime ? format(new Date(file.updateTime), 'MM/dd/yyyy - HH:mm:ss a') : '--')
  },
  {
    Header: 'Start Date',
    id: 'startDate',
    type: 'string',
    disableSortBy: true,
    accessor: file => (file.startDate ? format(new Date(file.startDate), 'MM/dd/yyyy') : '--')
  },
  {
    Header: 'End Date',
    id: 'endDate',
    type: 'string',
    disableSortBy: true,
    accessor: file => (file.endDate ? format(new Date(file.endDate), 'MM/dd/yyyy') : '--')
  },
  {
    Header: 'Status',
    id: 'status',
    type: 'string',
    disableSortBy: true,
    accessor: file => {
      if (file.status) {
        const { statusClass, label } = mapStatusToClass(file.status);

        return (
          <span className={`status badge badge-pill badge-outline-${statusClass}`}>{utils.capitalize(label)}</span>
        );
      }
      return <span className="status badge badge-pill badge-outline-secondary">Undefined</span>;
    }
  },
  {
    Header: 'Processed Date',
    id: 'processedTime',
    type: 'string',
    disableSortBy: true,
    accessor: file => (file.processedTime ? format(new Date(file.processedTime), 'MM/dd/yyyy') : '--')
  },
  {
    Header: '',
    id: 'actions',
    type: 'actions',
    disableSortBy: true,
    accessor: file => (
      <IconButton key={file.id} icon="trash" onPress={() => callbackFunction && callbackFunction(file)} />
    )
  }
];

export default createColumns;
